import {InjectionToken} from '@angular/core';

export const INVITE_AUTH_TOKEN = new InjectionToken('Invite code');
